import { render } from "./powerCoupleSection.vue?vue&type=template&id=f36e35ee"
import script from "./powerCoupleSection.vue?vue&type=script&lang=js"
export * from "./powerCoupleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__